import React from "react";
import { formatNumber } from "../../../../../Utils/utils";

interface FirstCardModalityDetailProps {
  selectedModality: any;
  data: any;
  typeMoneyDescriptionList: any;
  isRecalculate?: boolean;
}

const FirstCardModalityDetail = ({
  selectedModality,
  data,
  typeMoneyDescriptionList,
  isRecalculate = false,
}: FirstCardModalityDetailProps) => {
  const findProductByMatch = () => {
    if (!data.producto || !Array.isArray(data.producto)) {
      return null;
    }

    const matchedProduct = data.producto.find((producto: any) => {
      if (producto.modalidad !== selectedModality.modalidad) {
        return false;
      }

      const periodoGarantizado = parseInt(selectedModality.periodoGarantizado || "0");
      const anosRT = parseInt(selectedModality.anosRT || "0");

      if (producto.periodoGarantizado !== periodoGarantizado) {
        return false;
      }
      if (producto.anosRT !== anosRT) {
        return false;
      }

      return true;
    });

    return matchedProduct;
  };

  const productMatch = !selectedModality.respuestaMacro ? findProductByMatch() : null;
  const respuestaMacro = selectedModality.respuestaMacro || (productMatch && productMatch.respuestaMacro);
  const periodoDiferido = parseInt(
    respuestaMacro && respuestaMacro.periodoDiferido
      ? respuestaMacro.periodoDiferido
      : "0",
    10
  );
  const tasaVentaActual = respuestaMacro
    ? periodoDiferido > 0
      ? respuestaMacro.tasaInteresRt
      : respuestaMacro.tasaInteresRv
    : null;

  return (
    <div className="card-verify">
      {isRecalculate && (
        <div className="card-verify__header">
          <div
            className="card-verify__title"
            style={{ fontSize: "14px", fontWeight: "bold" }}
          >
            VALORES RECALCULADOS
          </div>
        </div>
      )}
      <div className="card-verify__rows">
        <div>
          <div className="card-verify__quote">Nro. Cotización</div>
          <div className="card-verify__data">{data.nroOperacion}</div>
        </div>
        <div>
          <div className="card-verify__quote">Modalidad</div>
          <div className="card-verify__data">
            {data.estado === "recalculado"
              ? data.modalidadRecalculada.modalidad
              : selectedModality.modalidad}
          </div>
        </div>
        <div>
          <div className="card-verify__quote">Diferimiento</div>
          <div className="card-verify__data">
            {data.estado === "recalculado"
              ? data.modalidadRecalculada.anosRT
              : selectedModality.anosRT}
          </div>
        </div>
      </div>
      <div className="card-verify__rows-line"></div>
      <div className="card-verify__rows">
        <div>
          <div className="card-verify__quote">Garantizado</div>
          <div className="card-verify__data">
            {data.estado === "recalculado"
              ? data.modalidadRecalculada.periodoGarantizado
              : selectedModality.periodoGarantizado}
          </div>
        </div>
        <div>
          <div className="card-verify__quote">Capital Pensión</div>
          <div className="card-verify__data">
            {data.estado === "recalculado"
              ? data.modalidadRecalculada && data.modalidadRecalculada.recalculo
                ? formatNumber.new(data.modalidadRecalculada.recalculo.primaCia)
                : "--"
              : respuestaMacro
                ? formatNumber.new(respuestaMacro.primaCia)
                : "--"}
          </div>
        </div>
        <div>
          <div className="card-verify__quote">Moneda</div>
          <div className="card-verify__data">
            {typeMoneyDescriptionList[selectedModality.moneda]}
          </div>
        </div>
      </div>
      <div className="card-verify__rows-line"></div>
      <div className="card-verify__rows">
        <div>
          <div className="card-verify__quote">Reajuste</div>
          <div className="card-verify__data">
            {data.estado === "recalculado"
              ? data.modalidadRecalculada.reajuste
              : selectedModality.reajuste || (productMatch && productMatch.reajuste) || "--"}
          </div>
        </div>
        {respuestaMacro && (
          <>
            <div>
              <div className="card-verify__quote">Prima Única AFP</div>
              <div className="card-verify__data">
                {data.estado === "recalculado"
                  ? data.modalidadRecalculada &&
                    data.modalidadRecalculada.recalculo &&
                    data.modalidadRecalculada.recalculo.primaAfp
                    ? formatNumber.new(
                      data.modalidadRecalculada.recalculo.primaAfp
                    )
                    : "--"
                  : respuestaMacro.primaAfp
                    ? formatNumber.new(respuestaMacro.primaAfp)
                    : "--"}
              </div>
            </div>
            <div>
              <div className="card-verify__quote">Tasa de Venta Actual</div>
              <div className="card-verify__data">
                {tasaVentaActual ? `${tasaVentaActual}%` : "--"}
              </div>
            </div>

          </>
        )}
        <div>
          <div className="card-verify__quote">CIC definitivo</div>
          <div className="card-verify__data">
            {data.estado === "recalculado"
              ? formatNumber.new(data.modalidadRecalculada.cic)
              : productMatch && productMatch.reajuste && !productMatch.cic && respuestaMacro
                ? formatNumber.new(respuestaMacro.primaCia)
                : "--"}
          </div>
        </div>
        { isRecalculate && (
            <div>
              <div className="card-verify__quote">Tipo de Cambio</div>
              <div className="card-verify__data">
                {data && data.modalidadRecalculada && data.modalidadRecalculada.tipoCambio || '--'}
              </div>
            </div>
          )
        }
      </div>
    </div>
  );
};

export default FirstCardModalityDetail;
